export default "__VITE_ASSET__DOoOg7Y2__"